<div class="snackbar-wrapper">
  <div class="snackbar-content">
    <app-notification class="snackbar-card" [color]="message.type === 'success' ? '#6aa33e' : '#e37055'"
                      [icon]="message.type === 'success' ? 'check' : 'danger'"
                      [buttonMessage]="message.buttonMessage"
                      (onButtonClick)="message.buttonFunction ? message.buttonFunction() : ''"
                      *ngFor="let message of messages">{{ message.content}}</app-notification>
  </div>
</div>
